import { Box, Typography } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import * as CanLaunchPathwayByParentPathway from "utils/graphql/CanLaunchPathwayBySequencialParentPathway";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { colors } from "components/theme/colors";
import { ContentType } from "utils/graphql/Global";

const WarningMessage = withStyles(() => ({
  root: {
    color: colors.orange["500"],
    fontSize: "12px",
    fontWeight: "bold",
    marginBottom: "1rem",
  },
}))(Typography);
interface PathwayWarningProps {
  data?: CanLaunchPathwayByParentPathway.CanLaunchPathwayBySequencialParentPathway;
  onClick?: () => void;
}

export function PathwayWarning({ data, onClick }: PathwayWarningProps): React.ReactElement {
  const localeKey = getWarningMessageKey(data);
  const { t } = useTranslation();

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return localeKey ? (
    <Box>
      <WarningMessage>
        <Trans i18nKey={localeKey} t={t}>
          <span>
            {data?.canLaunchPathwayBySequencialParentPathway?.blockingPathways?.map((pathway) => (
              <Link
                onClick={handleClick}
                key={pathway?.id}
                to={`/${ContentType.PARENT_PATHWAY}/${pathway?.id}`}
                style={{ margin: "0 2px", textDecoration: "underline" }}
              >
                {pathway?.name}
              </Link>
            ))}
          </span>
        </Trans>
      </WarningMessage>
    </Box>
  ) : (
    <></>
  );
}

export const getWarningMessageKey = (
  data?: CanLaunchPathwayByParentPathway.CanLaunchPathwayBySequencialParentPathway
): string => {
  const blockingPathwayNames: string[] = [];
  if (data?.canLaunchPathwayBySequencialParentPathway?.blockingPathways?.length) {
    data?.canLaunchPathwayBySequencialParentPathway?.blockingPathways.forEach((pathway) => {
      if (pathway && pathway.name) {
        blockingPathwayNames.push(pathway.name);
      }
    });
  }
  if (
    Boolean(data?.canLaunchPathwayBySequencialParentPathway?.canLaunch) ||
    (!Boolean(data?.canLaunchPathwayBySequencialParentPathway?.canLaunch) &&
      blockingPathwayNames.length === 0)
  ) {
    return "";
  }
  return "blocked_pathway_warning_message";
};
